// extracted by mini-css-extract-plugin
export var deleteModal = "_fy-0";